import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';

import { getAppConfig } from 'src/app/store/app-config/app-config.actions';
import { selectAppConfigState } from 'src/app/store/app-config/app-config.selectors';

import { AppConfigModel } from '../../../core/api/app-config.service';
import * as fromApp from '../../../store/index';

@Component({
  selector: 'fc-manage-app-config-page',
  templateUrl: './manage-app-config-page.component.html',
  styleUrls: ['./manage-app-config-page.component.scss'],
})
export class ManageAppConfigPageComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  displayedColumns: string[] = ['key', 'description', 'value'];

  dataSource: MatTableDataSource<AppConfigModel>;
  appConfig: Array<AppConfigModel>;

  constructor(readonly router: Router, readonly store: Store<fromApp.AppState>) {}

  ngOnInit() {
    this.queryAppConfig();

    this.store
      .select(selectAppConfigState)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(state => {
        this.appConfig = cloneDeep(state.appConfig);
        this.appConfig.sort((a: any, b: any) => {
          if (a.key < b.key) {
            return -1;
          } else if (a.key > b.key) {
            return 1;
          } else {
            return 0;
          }
        });
        this.dataSource = new MatTableDataSource(this.appConfig);
      });
  }

  queryAppConfig(): void {
    this.store.dispatch(getAppConfig());
  }

  clickRow(event: MouseEvent, row: AppConfigModel): void {
    this.router.navigate(['/admin/manage/app-config/edit', row.id]);
  }
}
